import { useEffect, useState } from 'react';
import { resolveStorageUrl } from '@/services/firebase/storage';

/** A Storage path → a renderable URL, or null while resolving / after failure. */
export function useStorageUrl(path: string | undefined): string | null {
  const [url, setUrl] = useState<string | null>(null);

  useEffect(() => {
    if (!path) return;
    let cancelled = false;
    resolveStorageUrl(path)
      .then((resolved) => {
        if (!cancelled) setUrl(resolved);
      })
      .catch(() => {
        if (!cancelled) setUrl(null);
      });
    return () => {
      cancelled = true;
    };
  }, [path]);

  return path ? url : null;
}
